import AWS from '@/assets/aws.js'
import DataManager from '@/assets/DataManager.js'
import SearchDataParser from '@/assets/SearchDataParser.js'
import axios from 'axios'

/* SMART SEARCH */
const SmartSearch = new function() {
	this.kommuneKode = '420|480|430|440|482|410|450|461|479';
	this.debug = false;
	this.searchData = [];
	this.searchDataExpanded = [];
	this.awsResults = [];
	this.autocompleteResults = [];
	this.priorityResults = [];
	this.searchResult = [];

	DataManager.getData([
			DataManager.keyWords,
			DataManager.recommendData,
			DataManager.tagSearchList,
			DataManager.searchData,
			DataManager.searchDataExpanded,
			DataManager.tagList,
			DataManager.menuList,
		], (response) => {
		this.keyWords = response[0].data;
		this.recommended = response[1].data;
		this.tagSearchList = response[2].data;
		this.searchData = SearchDataParser(response[3].data, response[4].data).searchData;
		this.searchDataExpanded = SearchDataParser(response[3].data, response[4].data).searchDataExpanded;
		this.tagList = response[5].data;
		this.menuList = response[6].data;
	});

	//Ban list
	this.banList = ['Afroditevej', 'Benedikts Plads', 'Bergsøes Plads', 'Bolbrogade', 'Bostongade', 'Branddamvej', 'Brejngaardsvej', 'Bøgeskovvej', 'Carl Nielsens Kvarter', 'Carl Nielsens Plads', 'Deleurans Plads', 'Drejebænken', 'Drøjsbjerggyden', 'Estlandkaj', 'Flintagervej', 'Flittergræsset', 'Fynske Motorvej', 'Glasgowgade', 'Gultvedvej', 'Halmstadsgade', 'Hauges Plads', 'H.C. Andersens Torv', 'Hedvigslund', 'Hellevad', 'Israels Plads', 'Jordemodersmutten', 'Kinopladsen', 'Landskronagade', 'Lindvedhave', 'Lysbjergvej', 'Lysekilgade', 'Lærkesporen', 'Løkkerisvej', 'Morten Korchs Plads', 'Munkebjerg Plads', 'Måneruden', 'Narvikgade', 'Nyenstad', 'Nørre Boulevard', 'Odense Å Sti', 'Odins Bro', 'Oliekaj', 'Oluf Bagers Plads', 'Paraplyen', 'Pjente Plads', 'Richard Møller Nielsens Plads', 'Ruslandkaj', 'Rørdamvej', 'Skibhusmarken', 'Skotlandgade', 'Skotlandkaj', 'Skt. Knuds Plads', 'Stavangergade', 'Stenfiskerkajen', 'Stykgodskajen', 'Svendborgmotorvejen', 'Sømosegårdvej', 'Søndre Hospitalsvej', 'Tidselgyden', 'Toldbodkaj', 'Tromsøgade', 'Tværgyden', 'Tysklandkaj', 'Tønsberggade', 'Vasagade', 'Vesterbankevej', 'Vestre Boulevard', 'Vestre Kanaldæmning', 'Østre Plads', 'Østre Ringvej'];

	this.commonStreetEndings = ["vej", "gade", "alle", "allé", "stræde", "passage", "park", "parken", "have", "haven", "torv", "plads"];

	// function for checking if the user has misspelled fx. brandts passage as brandtspassage
	this.checkForCommonStreetEnding = function(input){
		var se = SmartSearch.commonStreetEndings;
		var withNumber = false;
		var rest = [];
		if(input.match(/\d+/g) != null){
			withNumber = true;
			var ip = input.split(" ");
			for(var i = ip.length - 1; i > 0; i--){
				if(ip[i].match(/\d+/g) != null){
					rest.push(ip[i]);
					delete ip[i]

					break;
				}
				else{
					rest.push(ip[i]);
					delete ip[i];
				}
			}

			input = ip.join(" ").trim();
		}

		if(rest.length == 0){
			rest = false;
			input = input.trim();
		}
		else{
			rest = rest.reverse().join(" ");
		}

		var il = input.length;

		var matches = [];
		for(var e in se){
			var lookFor = "";
			for(var l in se[e]){
				lookFor += se[e][l];

				if(input.lastIndexOf(lookFor) == -1){
					continue;
				}
				var i = (input.lastIndexOf(lookFor) + lookFor.length - 1) + 1;

				if(i == il){
					matches.push({lookFor: lookFor, index: e});
				}
			}
		}

		if(matches.length == 0){
			return false;
		}


		matches.sort(function(a, b){
		  return b.lookFor.length - a.lookFor.length;
		});

		var pos = input.lastIndexOf(matches[0].lookFor);

		if(withNumber){
			return input.substring(0,pos) + " " + se[parseInt(matches[0].index)] + ((!!rest) ? " " + rest : "");
		}

		return input.substring(0,pos) + " " + matches[0].lookFor + input.substring(pos+matches[0].lookFor.length) + ((!!rest) ? " " + rest : "");
	};

	//Primary search function
	this.searchAddresses = function(obj, callback) {
		this.tagsResults = [];

		SmartSearch.resetPriorityList();

		//Activate debugmode
		if(obj.value == "!!debugmode"){
			alert("Debug mode on");
			var c = document.createElement("link");
			c.setAttribute("rel", "stylesheet");
			c.setAttribute("type", "text/css");
			c.setAttribute("href", "apptools/console/console.css");
			document.getElementsByTagName("head")[0].appendChild(c);

			var s = document.createElement("script");
			s.src="apptools/console/console.js";
			s.onload = function(){
				CJS.activate();
			}
			document.getElementsByTagName("body")[0].appendChild(s);
		}

		SmartSearch.searchResult.length = 0;
		SmartSearch.autocompleteResults.length = 0;
		SmartSearch.awsResults.length = 0;
		var input = obj.value;
		if(input.length > 2) {
			if(input.match(/\d+/g) != null) {

				var request = new XMLHttpRequest();
				request.open('GET', 'https://dawa.aws.dk/adgangsadresser/autocomplete?q='+encodeURIComponent(input)+'&per_side=100&kommunekode='+SmartSearch.kommuneKode, true);
				request.onload = function() {
				  if(this.status >= 200 && this.status < 400) {
				    var data = JSON.parse(this.response);
						if(SmartSearch.debug) {
							console.log('Adgangsadresser:');
							console.log(data);
						}

						if(data.length == 0 && /^.+\d*\s?-\s?\d*.+$/.test(input)) {
							SmartSearch.multiNumberSearch(input, obj, callback);
						}
						else if(data.length == 0) {
							var newinput = SmartSearch.checkForCommonStreetEnding(input);

							if(!!newinput){
								data = JSON.parse(AWS.ajax("https://dawa.aws.dk/adgangsadresser/autocomplete?q="+encodeURIComponent(newinput)+"&kommunekode="+SmartSearch.kommuneKode));

								if(data.length != 0){
									for(var i in data) {
										var item = {name: data[i].tekst, type: 'Adresse', href: data[i].adgangsadresse.href}
										//SmartSearch.autocompleteResults.push(item);
										SmartSearch.addToPriorityList(item, "addresses_autocomplete");
									}
									SmartSearch.sortData(obj, callback);
								}
								else{
									SmartSearch.fuzzySearch(input, obj, callback);
								}
							}
							else{
								SmartSearch.fuzzySearch(input, obj, callback);
							}
						}

						else {
							for(var i in data) {
								var item = {name: data[i].tekst, type: 'Adresse', href: data[i].adgangsadresse.href}
								//SmartSearch.autocompleteResults.push(item);

								SmartSearch.addToPriorityList(item, "addresses_autocomplete");
							}
							SmartSearch.sortData(obj, callback);
						}
				  }
					else {
				    console.log('AWS error');
				  }
				};

				request.onerror = function() {
				  console.log('AWS connection error');
				};

				request.send();
			}
			else {
				// tjek om input ligger gemt fra tidligere
				var data = AWS.searchForStreetsOnFyn(input);

				if(SmartSearch.debug) {
					console.log('Vejnavne:');
					console.log(data);
				}

				if(data == false){
					var newinput = SmartSearch.checkForCommonStreetEnding(input);

					if(!!newinput){
						data = AWS.searchForStreetsOnFyn(newinput);
					}
				}

				// check for fx søndergade odense
				input = input.toLowerCase();
				if(data == false){
					var data2 = AWS.searchForStreetsOnFyn(input, true);

					data = [];
					for(var d in data2){
						var n = data2[d].street.toLowerCase();
						var c = data2[d].comune.toLowerCase().split(" ");

						if(input.indexOf(n) != -1 && input.indexOf(c[0]) != -1){
							data.push(data2[d]);
						}
					}

					if(data.length == 0){
						data = false;
					}

				}

				// gem data
				var addToFullMatch = [];

				for(var i in data) {
					if(SmartSearch.banList.indexOf(data[i].tekst) == -1) {
						var item = {name: data[i].street, type: 'Vej', href: 'https://dawa.aws.dk/adgangsadresser?vejnavn='+data[i].street+'&postnr='+data[i].code, comune: data[i].comune, code: data[i].code}

						if(item.name.toLowerCase() == input){
							addToFullMatch.push(item);
						}
						else{
							SmartSearch.addToPriorityList(item, "addresses");
						}
					}
				}

				for(var i = addToFullMatch.length - 1; i >= 0; i--){
					SmartSearch.addToPriorityList(addToFullMatch[i], "full_match");
				}
				SmartSearch.sortData(obj, callback);
			}
		}
	};

	this.fuzzySearch = function(input, obj, callback){
		// with the fuzzy parameter on, aws returns a much wider list of suggestions
		axios.get('https://dawa.aws.dk/adgangsadresser/autocomplete?q='+encodeURIComponent(input)+'&kommunekode='+SmartSearch.kommuneKode+'&fuzzy=true')
	  .then((response) => {
			var data = response.data;
			if(SmartSearch.debug) {
				console.log('Fuzzy:');
				console.log(data);
			}
			var parts = input.split(" ");
			var nr = false;

			for(var p in parts){
				if(/\d/.test(parts[p])){
					nr = " "+parts[p];
					break;
				}
			}

			//var searchedName = input.split(nr)[0].toLowerCase();
			if(!!nr){
				var data = SmartSearch.filterMultiNumberResults(data, nr);

				for(var i in data) {
					var item = {name: data[i].tekst, type: 'Adresse', href: data[i].adgangsadresse.href}
					//SmartSearch.searchResult.push(item);

					SmartSearch.addToPriorityList(item, "addresses");
				}
			}

			SmartSearch.sortData(obj, callback);
	  })
	  .catch(function (error) {
	    console.log(error);
	  });
	};

	this.multiNumberSearch = function(input, obj, callback){
		var origNumbers = input.match(/\d*\s?-\s?\d*/)[0];
		var numbers = origNumbers.split("-");
		var restOfAddress = input.split(origNumbers);

		var res = [];

		for(var n in numbers){
			var number = numbers[n].trim();

			var a = restOfAddress[0] +" "+ number + ((restOfAddress[1]) ? " "+restOfAddress[1] : "");

			var r = AWS.ajax("https://dawa.aws.dk/adgangsadresser/autocomplete?q="+encodeURIComponent(a)+"&kommunekode="+SmartSearch.kommuneKode);


			r = SmartSearch.filterMultiNumberResults(JSON.parse(r), number);


			res.push(r);
		}

		for(var r in res){
			var data = res[r].reverse();
			for(var i in data){
				var item = {name: data[i].tekst, type: 'Adresse', href: data[i].adgangsadresse.href}
				//SmartSearch.searchResult.push(item);
				SmartSearch.addToPriorityList(item, "addresses");
			}
		}

		SmartSearch.sortData(obj, callback);

	};

	this.filterMultiNumberResults = function(res, number){
		var newRes = [];
		for(var r in res){
			var n = parseInt(res[r].adgangsadresse.husnr);
			if(n == number){
				newRes.push(res[r]);
			}

		}

		return newRes;
	};

	// sorting order
	/*
	81 = By
	59 = Bydel
	51 = Parkering
	80 = Vej uden husnumre
	*/

	this.priorityList = [];
	this.priorityOrder = ["full_match", "keywords", "partial_match_at_start", "partial_match", "81", "59", "odense", "51", "80", "addresses", "addresses_autocomplete", "places"];
	this.placesFound = [];

	this.addToPriorityList = function(obj, cat){
		SmartSearch.priorityList[cat].push(obj);
		SmartSearch.placesFound.push({obj: obj, category: cat});
	};

	this.resetPriorityList = function(){
		//this.priorityList = [];
		this.placesFound = [];
		for(var p in SmartSearch.priorityOrder){
			this.priorityList[SmartSearch.priorityOrder[p]] = [];
		}
	};

	this.dateCheck = function(feature){
		if(feature.endDate == undefined || feature.endDate == null || !feature.endDate){
			return true;
		}

		var n = Date.now() / 1000;

		return (n < feature.endDate);
	};

	this.sortData = function(obj, callback){
		var search = obj.value.toLowerCase().replace(".", "").trim();
		var length = this.searchData.length;
		var result = [];
		SmartSearch.priorityResults.length = 0;

		for(var i = 0; i < length; i++){

			if(this.searchData[i] == undefined){
				continue;
			}

			var ss = search.split(" ");
			var match = true;
			var sName = this.searchData[i].name.toLowerCase();

			for(var s in ss){
				if(sName.indexOf(ss[s]) == -1){
					match = false;
				}
			}

			// check if the name of the place and the search value are similar enough to be accepted
			if(!match){
				var similar = search.similarityWith(sName);

				if(search.length < 5){
					if(similar > 0.8){
						match = true;
					}
				}
				else{
					if(similar > 0.8){
						match = true;
					}
				}
			}

			// if the first check didn't pass, then we check again with the values reversed in order to catch more results
			if(!match){
				var similar = sName.similarityWith(search);

				if(search.length < 5){
					if(similar > 0.8){
						match = true;
					}
				}
				else{
					if(similar > 0.8){
						match = true;
					}
				}
			}

			if(match) {
				var lcn = this.searchData[i].name.toLowerCase();
				if(this.searchData[i].tagId == undefined) {
					console.log(this.searchData[i]);
				}
				// full or partial match
				if(this.searchData[i].name && lcn == search){
					SmartSearch.addToPriorityList(this.searchData[i], "full_match");
				}
				else if(this.searchData[i].name && lcn.indexOf(search) != -1){
					if(lcn.indexOf(search) == 0){
						SmartSearch.addToPriorityList(this.searchData[i], "partial_match_at_start");
					}
					else{
						SmartSearch.addToPriorityList(this.searchData[i], "partial_match");
					}
				}
				// tag id match
				else if(SmartSearch.priorityList[this.searchData[i].tagId.toString()] != undefined){
					SmartSearch.addToPriorityList(this.searchData[i], this.searchData[i].tagId.toString());
				}
				// rest
				else {
					SmartSearch.addToPriorityList(this.searchData[i], "places");
				}

			}
		}

		// check addresses results for results from odense
		for(var i = 0; i < SmartSearch.priorityList["addresses"].length; i++){
			if(SmartSearch.priorityList["addresses"][i] != undefined) {
				if(SmartSearch.priorityList["addresses"][i].comune && SmartSearch.priorityList["addresses"][i].comune.indexOf("Odense") != -1 ||
					SmartSearch.priorityList["addresses"][i].tekst && SmartSearch.priorityList["addresses"][i].tekst.indexOf("Odense") != -1 ||
					SmartSearch.priorityList["addresses"][i].name.indexOf("Odense") != -1){

					SmartSearch.addToPriorityList(SmartSearch.priorityList["addresses"][i], "odense");

					delete SmartSearch.priorityList["addresses"][i];

				}
			}
		}

		// check autocomplete addresses results for results from odense
		for(var i = 0; i < SmartSearch.priorityList["addresses_autocomplete"].length; i++){
			if(SmartSearch.priorityList["addresses_autocomplete"][i].comune && SmartSearch.priorityList["addresses_autocomplete"][i].comune.indexOf("Odense") != -1 ||
				SmartSearch.priorityList["addresses_autocomplete"][i].tekst && SmartSearch.priorityList["addresses_autocomplete"][i].tekst.indexOf("Odense") != -1 ||
				SmartSearch.priorityList["addresses_autocomplete"][i].name.indexOf("Odense") != -1){

				SmartSearch.addToPriorityList(SmartSearch.priorityList["addresses_autocomplete"][i], "odense");

				delete SmartSearch.priorityList["addresses_autocomplete"][i];
			}
		}

		this.alreadyFoundTags = [];
			var first = [];

			for(var a in SmartSearch.tagSearchList){
				var x = parseInt(SmartSearch.tagSearchList[a]);

				// the value can be undefined due to the data being messy sometimes if not all of it has been published yet
				if(this.tagList[x] == undefined){
					continue;
				}

				var added = false;

				// avoid double entries
				SmartSearch.alreadyFoundTags.push(this.tagList[x].name.trim());
				SmartSearch.alreadyFoundTags.push(this.tagList[x].name_plural.trim());

				var n = this.tagList[x].name.toLowerCase();
				var pn = this.tagList[x].name_plural.toLowerCase();

				var d = this.stripTags(this.tagList[x].desc);

				var ni = n.indexOf(search);
				var pni = pn.indexOf(search);

				if(ni > -1 || pni > -1){
					if(ni == 0 || pni == 0){
						first.push(this.tagList[x]);
						added = true;
						continue;
					}

					SmartSearch.tagsResults.push(this.tagList[x]);
					added = true;
					continue;
				}

				// search in description
				if(!added && d != "" && d != undefined && d.toLowerCase().indexOf(search) != -1){
					SmartSearch.tagsResults.push(this.tagList[x]);
				}
			}

			for(var m in this.menuList){
				if(!this.dateCheck(this.menuList[m])){
					continue;
				}
				//console.log(this.menuList[m]);
				var n = this.menuList[m].title.toLowerCase();
				var d = this.stripTags(this.menuList[m].desc);

				var added = false;
				//console.log(n);
				var nn = n.split(" ");

				this.menuList[m].realType = "theme";

				for(var i in nn){
					if(nn[i].length < 3){
						continue;
					}

					var index = search.indexOf(nn[i])
					if(index > -1){
						// set an additional property that shows the real type, otherwise it will be seen as a group
						this.menuList[m].realType = "theme";
						if(index == 0){
							first.push(this.menuList[m]);
							added = true;
							break;
						}

						SmartSearch.tagsResults.push(this.menuList[m]);
						added = true;
						break;
					}
				}

				// search in description
				if(!added && d != "" && d != undefined && d.toLowerCase().indexOf(search) != -1){
					SmartSearch.tagsResults.push(this.menuList[m]);
				}


				// search children
				//if(app.supportsSearchInThemeChildren === true){
					for(var c in this.menuList[m].children){
						if(!this.dateCheck(this.menuList[m].children[c])){
							// avoid double entries
							if(SmartSearch.alreadyFoundTags.indexOf(this.menuList[m].children[c].title.trim()) != -1){
								continue;
							}

							// skip places
							if(this.menuList[m].children[c].type == "place"){
								continue;
							}

							var child_added = false;

							SmartSearch.alreadyFoundTags.push(this.menuList[m].children[c].title);

							var nn = this.menuList[m].children[c].title.toLowerCase().split(" ");

							for(var i in nn){
								if(nn[i].length <= 3){
									continue;
								}

								var index = nn[i].indexOf(search);

								if(index == -1){
									index = search.indexOf(nn[i]);
								}

								if(index > -1){
									//console.log(this.menuList[m].children[c]);

									if(index == 0){
										first.push(this.menuList[m].children[c]);
										child_added = true;
										break;
									}

									SmartSearch.tagsResults.push(this.menuList[m].children[c]);
									child_added = true;
									break;
								}
							}

							if(!child_added){
								var child_des = this.stripTags(this.menuList[m].children[c].desc);
								if(child_des != "" && child_des != undefined && child_des.toLowerCase().indexOf(search) != -1){
									SmartSearch.tagsResults.push(this.menuList[m].children[c]);
								}
							}
						}
					}
				//}

			}

			first = first.reverse();

			for(var f in first){
				SmartSearch.tagsResults.unshift(first[f]);
			}

			SmartSearch.lookInKeyWords(search);
		//}


		SmartSearch.searchInRecommended(search);


		for(var i = SmartSearch.priorityOrder.length - 1; i >= 0; i--){

			if(SmartSearch.priorityOrder[i] == "addresses_autocomplete"){
				/* Sort aws autocomplete results - requires a bit more work than the others */
				SmartSearch.priorityList[SmartSearch.priorityOrder[i]] = SmartSearch.sortList(SmartSearch.priorityList[SmartSearch.priorityOrder[i]], true);
			}
			else{
				SmartSearch.sortList(SmartSearch.priorityList[SmartSearch.priorityOrder[i]]);
			}

			// add the results to the final resultlist
			for(var a = 0; a < SmartSearch.priorityList[SmartSearch.priorityOrder[i]].length; a++){
				SmartSearch.searchResult.unshift(SmartSearch.priorityList[SmartSearch.priorityOrder[i]][a]);
			}
		}

		var placeExists = [];
		// format the resultlist so all results have the same properties
		for(var i = 0; i < SmartSearch.searchResult.length; i++) {

			if(SmartSearch.searchResult[i] == undefined){
				continue;
			}

			if(SmartSearch.searchResult[i].placeId != undefined || SmartSearch.searchResult[i].type == "item") {
				var placeId = parseInt(SmartSearch.searchResult[i].placeId) || parseInt(SmartSearch.searchResult[i].id);
				if(placeExists.indexOf(placeId) == -1) {
					placeExists.push(placeId);
				} else {
					continue;
				}
			}

			if(!SmartSearch.searchResult[i].type){
				if(this.tagList[SmartSearch.searchResult[i].tagId] != undefined){
					SmartSearch.searchResult[i].type = this.tagList[SmartSearch.searchResult[i].tagId].name;
				}
			}

			result.push({name: SmartSearch.searchResult[i].name,
						type: SmartSearch.searchResult[i].type,
						tagId: SmartSearch.searchResult[i].tagId,
						placeId: SmartSearch.searchResult[i].placeId || SmartSearch.searchResult[i].id,
						href: SmartSearch.searchResult[i].href,
						lat: SmartSearch.searchResult[i].lat,
						lng: SmartSearch.searchResult[i].lng,
						comune: SmartSearch.searchResult[i].comune,
						code: SmartSearch.searchResult[i].code
						});
		}

		SmartSearch.searchResult = result;

		if(SmartSearch.debug) {
			console.log(result);
		}
		if(callback && callback != undefined && callback != null){
			callback(result);
		}
	};

	this.stripTags = function(s){
		if(s == undefined){
			return "";
		}

		var d = document.createElement("div");
		d.innerHTML = s;

		return d.textContent || d.innerText || "";
	};


	// function for sorting the results alphabetically
	this.sortList = function(list, sortAutoComplete){

		if(sortAutoComplete){

			var temp = {};
			//list.reverse();
			for(var i = 0; i < list.length; i++){
				if(list[i] == undefined){
					continue;
				}

				var c = SmartSearch.splitValue(list[i].name, list[i].name.lastIndexOf(", "), 2)[1].split(" ")[0];

				c = parseInt(c);

				if(temp[c] == undefined){
					temp[c] = [];
				}

				temp[c].push(list[i]);
			}

			list = [];

			var keys = new Array();

			for(var k in temp){
				keys.unshift(k);
			}

			//keys.reverse();

			list.sort(function(a, b) {
				return ((a < b) ? 1 : ((a > b) ? -1 : 0));
			});

			for(var t = keys.length - 1; t >= 0; t--){
				for(var a in temp[keys[t]]){
					list.push(temp[keys[t]][a]);
				}
			}

			return list.reverse();
		}


		list.sort(function(a, b) {
			var aName = a.name.toLowerCase();
			var bName = b.name.toLowerCase();
			return ((aName < bName) ? 1 : ((aName > bName) ? -1 : 0));
		});
	};


	this.splitValue = function(value, index, offset) {
		offset = offset || 0;

		return [value.substring(0, index), value.substring(index + offset)];
	}
	this.alreadyFoundTags = [];

	this.alreadyFoundKeyWords = [];

	this.lookInKeyWords = function(search){
		this.alreadyFoundKeyWords = [];

		var sea = search.split(" ");

		for(var s in SmartSearch.keyWords){

			var match = true;

			for(var se in sea){
				if(s.indexOf(sea[se]) == -1){
					match = false;
				}
			}

			if(match){
				for(var k in SmartSearch.keyWords[s]){
					if(this.alreadyFoundKeyWords.indexOf(this.keywordIdForCheck(SmartSearch.keyWords[s][k])) != -1 || SmartSearch.keyWords[s][k].tagId == "1"){
						continue;
					}

					var found = false;

					if(SmartSearch.keyWords[s][k].type == "tag"){
						for(var t in SmartSearch.tagsResults){
							if(SmartSearch.tagsResults[t].id == SmartSearch.keyWords[s][k].tagId){
								found = true;
							}
						}
					}

					if(found){
						continue;
					}

					if(SmartSearch.keyWords[s][k].type == "tag"){
						SmartSearch.tagsResults.push(SmartSearch.keyWords[s][k]);
					}
					else{
						//SmartSearch.searchResult.unshift(SmartSearch.keyWords[s][k]);
						SmartSearch.priorityList["keywords"].push(SmartSearch.keyWords[s][k]);

						for(var p in SmartSearch.placesFound){
							if(SmartSearch.placesFound[p].obj.tagId == SmartSearch.keyWords[s][k].tagId){
								var cat = SmartSearch.placesFound[p].category;

								for(var l in SmartSearch.priorityList[cat]){
									if(SmartSearch.priorityList[cat][l].id == SmartSearch.placesFound[p].obj.id){
										//delete SmartSearch.priorityList[cat][l];

										break;
									}
								}

							}
						}
					}

					this.alreadyFoundKeyWords.push(this.keywordIdForCheck(SmartSearch.keyWords[s][k]))

				}
			}
		}
	};

	this.keywordIdForCheck = function(kw){
		if(kw.id != undefined){
			return kw.id;
		}

		return "t"+kw.tagId;
	};

	this.searchInRecommended = function(search){
		for(var r in this.recommended){

			if(this.recommended[r] == undefined){
				continue;
			}

			var found = false;

			this.recommended[r].tagId = this.recommended[r].tag_id || this.recommended[r].group_id;

			for(var t in SmartSearch.tagsResults){
				if(SmartSearch.tagsResults[t].id == this.recommended[r].tagId){
					found = true;
				}
			}

			if(found){
				continue;
			}

			var n = this.recommended[r].title;
			var d = this.stripTags(this.recommended[r].desc);

			if(n.toLowerCase().indexOf(search) != -1){
				this.tagsResults.push(this.addMissingTagId(this.recommended[r]));
			}
			else if(d != null && d.toLowerCase().indexOf(search) != -1){
				this.tagsResults.push(this.addMissingTagId(this.recommended[r]));
			}

		}
	};

	this.addMissingTagId = function(a){
		var r = {};

		// make a copy
		for(var i in a){
			r[i] = a[i];
		}

		if(r.type != "place" && r.tagId != undefined || r.type == "item" && r.tagId != undefined){
			return r;
		}

		var id = parseInt(r.item_id);

		for(var e in this.searchDataExpanded){
			if(this.searchDataExpanded[e].placeId == id){
				r.tagId = this.searchDataExpanded[e].tagId;
				r.type = "item";
				r.id = r.item_id;
				break;
			}
		}

		return r;
	};

}

Object.defineProperty(String.prototype, "similarityWith", {
	enumerable: false,
	value: function(b, log){
		var a = this.replace(/å/g, "aa");
		b = b.replace(/å/g, "aa");
		log = log || false;
		var al = a.length;
		var bl = b.length;

		if(al < 1 || bl < 1) return 0;
		if(a == b) return 1;

		var res = 0;
		var sim = 0;

		var checked = [];

		for(var i = 0; i < al; i++){
			var z = b.indexOf(a[i]);


			if(z != -1){
				var indices = [];
				for(var x = 0; x < bl; x++){
					if(b[x] === a[i]){
						indices.push(x);
					}
				}

				for(var y in indices){
					var a1 = (a[i - 1] + a[i]).replace("undefined", "").replace(" ", "");
					var a2 = (a[i] + a[i + 1]).replace("undefined", "").replace(" ", "");

					var a3 = a1[0] + a2;

					if(checked.indexOf(a3) != -1){
						continue;
					}

					checked.push(a3);

					if(b.indexOf(a3) != -1){
						sim++;

						continue;
					}


					if(b.indexOf(a1) != -1){
						sim += 0.5;
					}

					if(b.indexOf(a2) != -1){
						sim += 0.5;
					}
				}

				//b = b.replace(a[i], "");
				if(log){
					console.log("%c"+a[i] + " - " + z, "color: green;");
				}
			}
			else{
				if(log){
					console.log("%c"+a[i] + " - " + z, "color: red;");
				}
			}
			if(log){
				console.log(b);
			}
		}
		res = sim / al;
		return res;
	}
});

export default SmartSearch;
